import AxiosInstance from "services/api";

export const CounterCardService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/counter-card", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/counter-card/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/counter-card", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/counter-card/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/counter-card/${id}`);
  },
};
